/** Titles made from a request stay short enough to read at a glance. */
export const TASK_TITLE_FROM_REQUEST_MAX_LENGTH = 80;

/**
 * A task created from a plain request: the first sentence becomes the title, and the whole
 * request stays as the description when the title does not already say all of it.
 */
export function taskFromRequest(request: string): { title: string; description?: string } {
  const text = request.trim();
  const firstLine =
    text
      .split(/\r?\n/)
      .find((line) => line.trim())
      ?.trim() ?? "";
  const sentence = /^.*?[.!?](?=\s|$)/.exec(firstLine)?.[0] ?? firstLine;
  const title = shorten(sentence.replace(/[.!?]+$/, "").trim() || sentence);
  return title === text.replace(/[.!?]+$/, "") ? { title } : { title, description: text };
}

function shorten(value: string): string {
  if (value.length <= TASK_TITLE_FROM_REQUEST_MAX_LENGTH) return value;
  const cut = value.slice(0, TASK_TITLE_FROM_REQUEST_MAX_LENGTH - 1);
  const atWord = cut.lastIndexOf(" ");
  return `${(atWord > TASK_TITLE_FROM_REQUEST_MAX_LENGTH / 2 ? cut.slice(0, atWord) : cut).trimEnd()}…`;
}
